import heic2any from 'heic2any'

/**
 * Detecta se um arquivo é HEIC/HEIF (formato padrão das fotos do iPhone).
 * Verifica pelo MIME type e também pela extensão do nome, pois no Safari iOS
 * o `file.type` pode vir vazio.
 */
export function isHeic (file) {
  if (!file) {
    return false
  }

  const type = (file.type || '').toLowerCase()
  if (type === 'image/heic' || type === 'image/heif') {
    return true
  }

  const name = (file.name || '').toLowerCase()
  return name.endsWith('.heic') || name.endsWith('.heif')
}

/**
 * Verifica se o arquivo é de um tipo permitido para upload (png, jpg, jpeg,
 * heic, heif ou pdf). Aceita HEIC/HEIF porque são convertidos para JPEG antes
 * do envio. Valida por MIME e por extensão (o Safari iOS pode não informar o
 * MIME type).
 */
export function isAllowedFile (file) {
  if (!file) {
    return false
  }

  const type = (file.type || '').toLowerCase()
  if (['image/png', 'image/jpeg', 'image/heic', 'image/heif', 'application/pdf'].includes(type)) {
    return true
  }

  const name = (file.name || '').toLowerCase()
  return ['.png', '.jpg', '.jpeg', '.heic', '.heif', '.pdf'].some(ext => name.endsWith(ext))
}

/**
 * Converte um arquivo HEIC para JPEG, preservando o nome base.
 */
async function convertHeicToJpeg (file) {
  const blob = await heic2any({
    blob: file,
    toType: 'image/jpeg',
    quality: 0.8
  })

  const converted = Array.isArray(blob) ? blob[0] : blob
  const baseName = (file.name || 'imagem').replace(/\.[^./\\]+$/, '')

  return new File([converted], `${baseName}.jpg`, { type: 'image/jpeg' })
}

/**
 * Normaliza a seleção de um v-file-input: converte arquivos HEIC para JPEG e
 * mantém os demais intactos. Preserva o formato de entrada (File -> File,
 * array -> array), que é o mesmo formato esperado pelo v-model do v-file-input.
 */
export async function normalizeFiles (input) {
  if (!input) {
    return input
  }

  if (Array.isArray(input)) {
    const result = []
    for (const file of input) {
      result.push(isHeic(file) ? await convertHeicToJpeg(file) : file)
    }
    return result
  }

  if (isHeic(input)) {
    return convertHeicToJpeg(input)
  }

  return input
}



// WEBPACK FOOTER //
// ./src/utils/imageFile.js